import React from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@common/hooks';
import FormHealthDocumentTemplate from './form-health-document-template';
import { createMessage } from 'works/legacy/lib/message-helper';
import { UpdateHealthDocumentItemTemplate } from 'works/graphql/works-list-item-template';
import { addErrorsToForm } from 'works/legacy/lib/form-helpers';

export default function EditHealthDocumentTemplate({ dismiss, item, form }) {
  const handleMutationCompletion = (response) => {
    if (response.updateHealthDocumentItemTemplate.errors) {
      addErrorsToForm(form, response.updateHealthDocumentItemTemplate.errors);

      createMessage(
        'error',
        'Failed to update Compliance Item. Please try again.'
      );
    } else {
      createMessage('success', 'Compliance Item updated!');
      dismiss();
    }
  };

  const [updateHealthDocument] = useMutation(UpdateHealthDocumentItemTemplate, {
    onCompleted: handleMutationCompletion,
    onError: () =>
      createMessage(
        'error',
        'Failed to update Compliance Item. Please try again.'
      ),
  });

  const handleSubmit = (values) => {
    updateHealthDocument({
      variables: {
        itemId: item.id,
        input: values,
      },
    });
  };

  const initialValues = {
    healthDocId: item.healthDoc.id,
    healthDocSubtype: item.healthDocSubtype,
    active: item.active,
    name: item.name,
    description: item.description,
    expirationType: item.expirationType,
    daysToExpiry: item.daysToExpiry,
    seasonStartsAt: item.seasonStartsAt,
    seasonEndsAt: item.seasonEndsAt,
  };

  return (
    <FormHealthDocumentTemplate
      showSeason={true}
      initialValues={initialValues}
      dismiss={dismiss}
      handleSubmit={handleSubmit}
      showExpiration
      form={form}
    />
  );
}

EditHealthDocumentTemplate.propTypes = {
  dismiss: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
};
